<p-toast [style]="{marginTop: marginTopValue}"></p-toast>
<p-toast key="center" class="center"></p-toast>
